import { render, staticRenderFns } from "./HdsTextField.vue?vue&type=template&id=08001d16&scoped=true&"
import script from "./HdsTextField.vue?vue&type=script&lang=ts&"
export * from "./HdsTextField.vue?vue&type=script&lang=ts&"
import style0 from "./HdsTextField.vue?vue&type=style&index=0&id=08001d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08001d16",
  null
  
)

export default component.exports